import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getMovimento from "../queries/getMovimento";

export default function useMovimento(movimentoId: number) {
  const resultQuery = useQuery([`${URLS.MOVIMENTOS_API}/${movimentoId}`], () => getMovimento(movimentoId));

  return resultQuery;
}
